import { render, staticRenderFns } from "./ProgramInfo.vue?vue&type=template&id=c454d9d6"
import script from "./ProgramInfo.vue?vue&type=script&lang=js"
export * from "./ProgramInfo.vue?vue&type=script&lang=js"
import style0 from "./ProgramInfo.vue?vue&type=style&index=0&id=c454d9d6&prod&lang=css"
import style1 from "./ProgramInfo.vue?vue&type=style&index=1&id=c454d9d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports